/** @jsxImportSource @emotion/react */
import { clubDetailsPageAnalytics } from '../../analyticsConsts';
import formatAddress from '../../utils/formatAddress';
import Text from '../Text';
import useStyles from './styles';

const { CLUB_TEAM_CARD_TITLE } = clubDetailsPageAnalytics;

const TeamCard = ({
  index,
  TeamName,
  League,
  FootballType,
  Division,
  PlaysOnDay,
  onClick,
  isOpen,
  clubname,
  gender,
  groupGender,
  ...rest
}) => {
  const styles = useStyles();

  const address = formatAddress({
    AddressLine1: rest.GroundAddressLine1,
    AddressLine2: rest.GroundAddressLine2,
    AddressLine3: rest.GroundAddressLine3,
    City: rest.GroundCity,
    PostCode: rest.GroundPostCode,
  });

  //converting clubname and teamname to array
  const splitClub = clubname?.toLowerCase().split(' ');
  const spliTeam = TeamName?.toLowerCase().split(' ');

  // trimming the string
  const trimClubName = clubname.toLowerCase().trim();
  let trimTeamName = TeamName.toLowerCase().trim();

  //filtering the clubname from teamname if string match returns null
  const filterTeam = spliTeam?.filter(value => !splitClub?.includes(value));
  const filterTeamTitle = filterTeam.join(' ');

  //filter for repeated names
  const filterMatched = spliTeam?.filter(value => splitClub?.includes(value));

  //finding match and replacing it
  const matchTeams = trimTeamName.match(trimClubName);
  const modifiedTeam = matchTeams
    ? trimTeamName.replace(matchTeams, '').trim()
    : filterTeamTitle.trim();

  // to remove repeated strings
  const removeRepeatedName = filterMatched.filter(
    (
      s => v =>
        s.has(v) || !s.add(v)
    )(new Set())
  );

  // checking whether name is repeated
  const filteredTeamName =
    !matchTeams && !filterTeamTitle ? removeRepeatedName.join(' ') : '';

  return (
    <button css={styles.base} onClick={onClick}>
      {TeamName && (
        <div css={styles.titleWrapper}>
          <Text
            id={`${CLUB_TEAM_CARD_TITLE}-${index}`}
            as="h4"
            css={styles.title}
          >
            {filteredTeamName
              ? filteredTeamName
              : modifiedTeam && modifiedTeam !== '-' && modifiedTeam !== '.'
              ? modifiedTeam
              : TeamName}
          </Text>
        </div>
      )}
      <div css={styles.infoWrapper}>
        <ol css={styles.listBullets}>
          {League && (
            <li>
              <div>
                <Text>
                <strong css={styles.strongFormat}>League: </strong>
                <span css={styles.infoValue}>{League}</span>
                </Text>
              </div>
            </li>
          )}
          {Division && Division !== 'No Division' && (
            <li>
              <div>
                <Text>
                <strong css={styles.strongFormat}>Division: </strong>
                <span css={styles.infoValue}>{Division}</span>
                </Text>
              </div>
            </li>
          )}
          {FootballType && (
            <li>
              <div css={styles.formatWrapper}>
                <Text>
                  <strong css={styles.strongFormat}>Format: </strong>
                  {groupGender}
                </Text>
                <Text>{FootballType}</Text>
              </div>
            </li>
          )}
          {address && (
            <li>
              {address && (
                <div css={styles.addressStyle}>
                  <Text>
                    <strong css={styles.strongFormat}>Address: </strong>{' '}
                    <span css={styles.infoAddress}>{address}</span>
                  </Text>
                </div>
              )}
            </li>
          )}
        </ol>
      </div>
    </button>
  );
};

export default TeamCard;
